import { axiosGetV3 } from '../../api/axios-handler';
import { useQuery } from '@tanstack/react-query';
import { ResourcesResponse } from './useResources';
import { useCrisisCheckOnSearchQuery } from './useCrisisCheck';

const getResources = async (
  clientId: number,
  tagGroupId?: number,
  tagIds?: number[],
  searchQuery?: string,
): Promise<ResourcesResponse> => {
  const params: any = {
    client_id: clientId,
  };
  if (tagGroupId) {
    params.tag_groups = tagGroupId.toString();
  }
  if (tagIds && tagIds.length > 0) {
    // Send tags as comma-separated string to match backend DelimitedListField format
    params.tags = tagIds.join(',');
  }
  if (searchQuery && searchQuery.trim().length > 0) {
    params.search = searchQuery.trim();
  }
  const response = await axiosGetV3('/resources/browse', params);
  return response.data;
};

export const useResourcesByTopic = (
  tagGroupId?: number,
  clientId?: number,
  tagIds?: number[],
  searchQuery?: string,
) => {
  useCrisisCheckOnSearchQuery(searchQuery);

  const isEnabled = !!clientId;

  // Create a stable key for tagIds to prevent unnecessary refetches
  const tagIdsKey = tagIds && tagIds.length > 0 ? [...tagIds].sort((a, b) => a - b).join(',') : undefined;

  return useQuery<ResourcesResponse>(
    ['resourcesByTopic', clientId, tagGroupId, tagIdsKey, searchQuery],
    () => getResources(clientId!, tagGroupId, tagIds, searchQuery),
    {
      enabled: isEnabled,
    },
  );
};
